import { ColDef } from "ag-grid-community";
import {
  colCreatedByName,
  colCreatedOn,
  colDescription,
  colModifiedByName,
  colName,
  colSelected,
  colUpdatedOn
} from "../../../../../../core/grids/CommonGridColumns";
import { IGridFns } from "../../../../../../core/grids/GridFunctions";
import { BenefitField } from "../../../../../../enums";
import { SHOW_BENEFIT_DESCRIPTION_SIDEPANEL } from "./modals/BenefitGrid_modals";
import { IModalContextModel } from "../../../../../../core/modalZ/context/IModalContext";

interface IGetBenefitsGridColumns {
  // modals: IActionGridModals;
  canEdit: boolean;
  organisationId: number;
  projectId: number;
  gridFns: IGridFns;
  modalService: IModalContextModel;
}

export const GetBenefitsGridColumns = (modelProps: IGetBenefitsGridColumns) => {
  let result: ColDef[] = [];

  if (modelProps.canEdit) {
    result.push(colSelected());
  }

  result.push(colName(modelProps.canEdit, modelProps.gridFns.updateTextField, BenefitField.name));
  result.push({
    ...colDescription(
      modelProps.canEdit,
      SHOW_BENEFIT_DESCRIPTION_SIDEPANEL(modelProps.organisationId, modelProps.projectId)
    ),
    wrapText: true,
    cellRenderer: params => {
      return <div className="grid-cell" dangerouslySetInnerHTML={{ __html: params.data.description }}></div>;
    }
  });
  result.push(colCreatedByName());
  result.push(colCreatedOn());
  result.push(colModifiedByName());
  result.push(colUpdatedOn());

  return result;
};
